export default {
  'status_checks.archive.error':
    'There was an issue archiving {{statusCheckName}} Health Check. Please try again later.',
  'status_checks.continuous.label': 'Continuous Health Check',
  'status_checks.delete.error':
    'There was an error while removing the Health Check. Please try again later.',
  'status_checks.delete.success': 'Health Check removed successfully',
  'status_checks.delete.label': 'Delete Health Check',
  'status_checks.edit.label': 'Edit Health Check',
  'status_checks.new.label': 'New Health Check',
  'status_checks.run.continuous.label':
    'Allow this Health Check to run continuously during your scenario (polling every 10 seconds)',
  'status_checks.label.singular': 'Health Check',
  'status_checks.label.plural': 'Health Checks',
  'status_checks.page_name': 'Health Checks',
  'status_checks.create': 'Create Health Check',
  'status_checks.authentication': 'Authentication',
  'status_checks.authentication_list': 'Authentication List',
  'status_checks.header.description':
    'Health Checks will be shared across your team for use in Scenarios as well as Services, if you have Reliability Management. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service or Scenario to fail.  If you don’t have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation. For Reliability Management, each of your services will need a Health Check to evaluate whether your Reliability Tests have passed or failed.',
  'status_checks.authentication_list.revoke.success':
    'Successfully revoked Authentication',
  'status_checks.create.edit_authentication.breadcrumb.label':
    'Edit Authentication',
  'status_checks.create.clone_status_check.header.title':
    'Clone {{statusCheckName}}',
  'status_checks.create.edit_status_check.subheader.edit_authentication.link.label':
    'Edit Authentication',
  'status_checks.create_new': 'Create New Health Check',
  'status_checks.edit': 'Edit Health Check',
  'status_checks.edit.edit_authentication.save.success.toast.message':
    'Authentication has been saved to your team integrations.',
  'status_checks.create.save_status_check_form.save_authentication.success.toast.message.link.text':
    'Health Checks Authentication',

  // Authentication
  'status_checks.authentication.revoke.dialog.title': 'Revoke Authentication?',

  // Authentication - AWS Authentication Types
  'status_checks.authentication.aws.authentication_type.select.prompt':
    'To authenticate, Gremlin can use a:',
  'status_checks.authentication.aws.authentication_type.select.aria.label':
    'AWS Authentication Type selection',
  'status_checks.authentication.aws.authentication_type.iam_role': 'IAM Role',
  'status_checks.authentication.aws.authentication_type.service_account':
    'Service Account',

  // Authentication - AWS Role Creation Methods
  'status_checks.authentication.aws.role_creation_method.select.prompt':
    'Role creation method:',
  'status_checks.authentication.aws.role_creation_method.select.aria.label':
    'AWS Role Creation Method selection',

  // Authentication - AWS Cloud Formation and Manual Role Authentication
  'status_checks.authentication.aws.iam_role.cloud_formation_method.title':
    'In order to create roles via Cloud Formation, you will need to be an IAM administrator with the correct permissions in AWS.',
  'status_checks.authentication.aws.iam_role.cloud_formation_method.step_1.title':
    'Do you have the correct IAM role and permissions?',
  'status_checks.authentication.aws.iam_role.cloud_formation_method.step_1.description':
    'In order to create roles via Cloud Formation, you will need to be an IAM administrator and signed into your AWS account in this browser.',
  'status_checks.authentication.aws.iam_role.cloud_formation_method.step_2.title':
    'Launch Stack',
  'status_checks.authentication.aws.iam_role.cloud_formation_method.step_2.description':
    'While logged into your AWS account, you can grant Gremlin access below. This will open in AWS.',
  'status_checks.authentication.aws.iam_role.manual_method.title':
    'Create a role in AWS IAM. We recommend calling it "gremlin-access".',
  'status_checks.authentication.aws.iam_role.manual_method.step_1.title':
    'Delegating role creation to a different team?',
  'status_checks.authentication.aws.iam_role.manual_method.step_1.description.part_1':
    'If a different team needs to review the policies and create the role for you, send them',
  'status_checks.authentication.aws.iam_role.manual_method.step_1.description.link.label':
    'this documentation',
  'status_checks.authentication.aws.iam_role.manual_method.step_1.description.part_2':
    'with the request.',
  'status_checks.authentication.aws.iam_role.manual_method.step_2.title':
    'Paste permission policy in AWS IAM',
  'status_checks.authentication.aws.iam_role.manual_method.step_3.title':
    'Paste trust policy in AWS IAM',
  'status_checks.authentication.aws.iam_role.manual_method.step_4.title':
    'Add the following managed policies',
  'status_checks.authentication.aws.iam_role.manual_method.step_4.description':
    'In AWS, click on Add permissions > Attach policies and select the managed policies listed below:',
  'status_checks.authentication.aws.iam_role.last_step.title':
    "Paste gremlin-access role's ARN",
  'status_checks.authentication.aws.iam_role.last_step.description':
    'After the template is completed in AWS, copy the RoleARN from the stack outputs and paste it here. If this task was delegated to another team, they will be able to provide this for you.',
  'status_checks.authentication.aws_iam_role_arn.text_field.label':
    'AWS IAM Role ARN',
  'status_checks.authentication.aws.iam_role.cloud_formation_method.launch_stack_button.label':
    'Launch Stack',
  'status_checks.authentication.aws.iam_role.arn_input.edit.message':
    '* Note: You can only edit this authentication using an ARN with the same Account ID. If you need to use an ARN from a different account, please create a new AWS Authentication.'
}
